<template lang="html">
  <div id="results-page">
    <section class="products-section py-5">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-4">
          <h1 class="catalog-title mb-3">Soluciones Tech</h1>
          <p class="lead text-muted mx-auto catalog-subtitle">
            Ofrecemos soluciones tecnológicas especializadas para diferentes industrias.
          </p>
        </div>

        <!-- Filtros -->
        <div class="mb-4">
          <!-- <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
            <div class="flex-grow-1"></div>
            <button type="button" class="btn btn-outline-secondary btn-sm">
              <i class="fa-solid fa-filter mr-2"></i>
              Filtros
            </button>
          </div> -->

          <!-- Familias -->
          <div class="d-flex flex-wrap">
            <button type="button" class="btn btn-sm mr-2 mb-2 catalog-filter-btn" :class="filters.family == '' ? 'btn-danger' : 'btn-outline-secondary'" @click="selectedFamily(null)">Todos</button>

            <button
              v-for="(family, fInx) in families"
              :key="'fInx-'+fInx"
              type="button"
              class="btn btn-sm mr-2 mb-2 catalog-filter-btn"
              :class="filters.family == family.id ? 'btn-danger' : 'btn-outline-secondary'"
              @click="selectedFamily(family.id)"
            >
              {{ family.name }}
            </button>
          </div>
        </div>

        <!-- Grid de productos -->
        <div class="row" v-if="!isLoading">
          <div
            v-for="(product, pInx) in products"
            :key="'pInx-'+pInx"
            class="col-12 col-md-6 col-lg-4 mb-4 box-product-s2"
          >
            <router-link :to="'/soluciones-tech/'+$root._converToURL(product.name, product.id)" class="text-decoration-none">
              <div class="card border-0 shadow catalog-product-card h-100">
                <div class="position-relative overflow-hidden catalog-product-img-wrap">
                  <img class="w-100 placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }" />
                  <span class="badge badge-primary catalog-product-badge">{{ product.brand }}</span>
                  <div class="catalog-product-eye">
                    <span class="btn btn-sm btn-light">
                      <i class="fa-solid fa-eye"></i>
                    </span>
                  </div>

                  <div class="position-absolute" style="bottom: 1rem; right: 1rem;">
                    <span class="badge badge-success" v-if="product.stock == true">
                      En Stock
                    </span>
                    <span v-else class="badge badge-secondary">
                      Agotado
                    </span>
                  </div>
                </div>

                <div class="card-body">
                  <h3 class="card-title catalog-product-name mb-2">
                    {{ product.name }}
                  </h3>
                  <p class="text-muted small mb-3 p-short-description">{{ product.short_description }}</p>

                  <div class="d-flex flex-wrap mb-3 box-tags" v-html="$root.generateProdBadge(product.keywords)"></div>

                  <div class="d-flex align-items-center justify-content-between flex-wrap box-bottom">
                    <div class="col col-price">
                      <span class="d-block text-muted small text-decoration-line-through" v-if="product.price_offer">
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small>
                      </span>
                      <span class="catalog-product-price" v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }} <small>USD</small></span>
                      <span class="catalog-product-price" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small></span>
                    </div>

                    <div class="col col-button">
                      <button
                        type="button"
                        class="btn btn-danger btn-sm w-100">
                        <i class="fa-solid fa-cart-shopping mr-1"></i>
                        Explorar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-12 col-pagination mt-2" v-if="!isLoading && products.length > 0">
            <b-pagination-nav class="nav-pagination" :link-gen="linkGen" :number-of-pages="totalPages" use-router></b-pagination-nav>
          </div>

          <div v-if="products.length === 0 && !isLoading" class="col-12">
            <div class="alert alert-light text-center py-5">
              No se encontraron productos que coincidan con tu búsqueda.
            </div>
          </div>
        </div>

        <loading-component-s1 v-if="isLoading"></loading-component-s1>

        <!-- CTA -->
        <div class="text-center mt-5">
          <h3 class="h4 font-weight-bold mb-2">¿No encuentras lo que buscas?</h3>
          <p class="text-muted mb-4">Contáctanos para obtener una cotización personalizada</p>
          <router-link to="/contacto" class="btn btn-danger btn-lg">
            Contactar Especialista
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,

      filters: {
        family: null,
        page: 1,
      },

      totalPages: 1,
      
      families: [
        // 'Todos',
        // 'Drones DJI',
      ],
      
      products: [],
    };
  },

  methods: {
    getProducts: function(){
      this.filters.family = this.$route.query.fam || '';
      this.filters.page = this.$route.query.page || 1;
      this.isLoading = true;

      axios.post(tools.url('/api/products/family?page='+this.filters.page), this.filters).then(({data}) =>{
        this.families = data.families;
        this.products = data.products.data;
        this.totalPages = data.products.last_page;
        this.isLoading = false;
      });
    },

    linkGen(pageNum) {
      let famID = (this.filters.family == '') ? '' : '='+this.filters.family;

      return pageNum === 1 ? `?fam${famID}&page=${1}` : `?fam${famID}&page=${pageNum}`;
    },

    selectedFamily: function(family){
      this.$router.push({ query: { fam: family, page: 1 } });
    },
  },

  mounted() {
    this.getProducts();
  },

  watch: {
    $route(to, from) {
      this.getProducts();
    }
  },
};
</script>
